import {gql} from 'apollo-angular';
import { Injectable } from '@angular/core';
import { Apollo } from '../../../node_modules/apollo-angular';
import { map } from '../../../node_modules/rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class GeneralService {
  transactionStatusesQuery = gql`
    query transactionStatuses {
      transactionStatuses {
        id
        name
      }
    }
  `;

  constructor(private apollo: Apollo) {}

  public allTStatuses(): any {
    return this.apollo
      .watchQuery({
        query: this.transactionStatusesQuery
      })
      .valueChanges.pipe(
        map((result: any) => result.data && result.data.transactionStatuses)
      );
  }
}
